export default __webpack_public_path__ + "static/media/icons8-nodejs.cccdafa9.svg";